function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 8 */
import { SessionStorageManager } from "./SessionStorageManager";
import { ArgumentException } from "./Exceptions";
import { ArgumentTypeException } from "./Exceptions";
var _keyPrefix = "mpp-return-context_";
/**
 * For internal use. Generates a full sessionStorage key - prefix + provided key
 * @param {string} key Storage key
 * @returns {string} Generated full storage key
*/

var _getKey = function _getKey(key) {
  return "".concat(_keyPrefix, "_").concat(key);
};
/**
 * Return context provider. Gets/sets context for a category of widgets
 */


export var ReturnContext = /*#__PURE__*/function () {
  function ReturnContext() {
    _classCallCheck(this, ReturnContext);
  }

  _createClass(ReturnContext, null, [{
    key: "Set",
    value:
    /**
     * Saves provided formData and current URL in session storage
     * @param {string} category Widget category
     * @param {FormData} formData FormData that needs to be stored
     * @throws {ArgumentException}
     * @throws {ArgumentTypeException}
     */
    function Set(category, formData) {
      if (!category) {
        throw new ArgumentException("category");
      }

      if (typeof category !== "string") {
        throw new ArgumentTypeException("category");
      }

      if (!formData) {
        throw new ArgumentException("formData");
      }

      if (_typeof(formData) !== "object" || !(formData instanceof FormData)) {
        throw new ArgumentTypeException("formData");
      }

      SessionStorageManager.clear(_keyPrefix);
      var formDataObject = {};

      var _iterator = _createForOfIteratorHelper(formData.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pair = _step.value;
          formDataObject[pair[0]] = !!formDataObject[pair[0]] ? formDataObject[pair[0]] + "," + pair[1] : pair[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var item = JSON.stringify({
        Url: window.location.href,
        FormData: formDataObject
      });
      SessionStorageManager.setItem(_getKey(category), item);
    }
    /**
     * Retrieves context for provided category from session storage
     * @param {string} category Widget category
     * @returns {object} If available returns object { url, formData }, if not - returns null
     * @throws {ArgumentException}
     * @throws {ArgumentTypeException}
     */

  }, {
    key: "Get",
    value: function Get(category) {
      if (!category) {
        throw new ArgumentException("category");
      }

      if (typeof category !== "string") {
        throw new ArgumentTypeException("category");
      }

      var item = SessionStorageManager.getItem(_getKey(category));
      return JSON.parse(item);
    }
    /**
     * Gets widget categories
     * @returns {object} JSON object {category, categoryName}
     */

  }, {
    key: "Categories",
    get: function get() {
      return {
        Groups: "Groups",
        Events: "Events",
        Opportunities: "Opportunities",
        OnlineDirectory: "OnlineDirectory",
        None: "None"
      };
    }
    /**
     * Apllies object values to the specified form element
     * @param {object} formData JSON object key/value pairs
     * @param {Form} form Form element
     * @returns {boolean} Indicates if hidden container should be open
     * @throws {ArgumentException}
     */

  }, {
    key: "ApplyFilter",
    value: function ApplyFilter(formData, form, hiddenContainer) {
      var inHiddenContainer = false;

      if (!formData) {
        throw new ArgumentException("formData");
      }

      if (!form) {
        throw new ArgumentException("form");
      }

      var formElements = [];

      for (var i = 0; i < form.elements.length; i++) {
        formElements.push(form.elements[i]);
      }

      var _loop = function _loop(key) {
        value = formData[key];
        var formElementMatches = formElements.filter(function (item) {
          return item.name == key;
        });

        for (var _i = 0; _i < formElementMatches.length; _i++) {
          var formElement = formElementMatches[_i];

          if (!!formElement) {
            var changed = false;

            if (formElement.type === "checkbox") {
              var checked = value.split(",").includes(formElement.value);

              if (formElement.checked != checked) {
                formElement.checked = checked;
                changed = true;
              }
            } else {
              if (formElement.value != value) {
                formElement.value = value;
                changed = true;
              }
            }

            if (!inHiddenContainer && changed) {
              if (!!hiddenContainer && hiddenContainer.contains(formElement)) {
                hiddenContainer.style.display = "";
                inHiddenContainer = true;
              }
            }
          }
        }
      };

      for (var key in formData) {
        var value;

        _loop(key);
      }

      return inHiddenContainer;
    }
  }]);

  return ReturnContext;
}();